import { termConstants } from '../constants/term.constants';

export function term(state = {}, action) {
  switch (action.type) {
    case termConstants.FETCH_REQUEST:
    case termConstants.GET_REQUEST:
    case termConstants.SAVE_REQUEST:
    case termConstants.DELETE_REQUEST:
    case termConstants.ACCEPTANCES_FETCH_REQUEST:
      return {
        ...state,
        loading: true
      };

    case termConstants.FETCH_SUCCESS:
      return {
        ...state,
        list: action.terms,
        loading: false
      };

    case termConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.term,
        loading: false
      };

    case termConstants.SAVE_SUCCESS:
    case termConstants.DELETE_SUCCESS:
      return {
        ...state,
        loading: false
      };

    case termConstants.ACCEPTANCES_FETCH_SUCCESS:
      return {
        ...state,
        acceptances: action.acceptances,
        loading: false
      };

    case termConstants.FETCH_FAILURE:
    case termConstants.GET_FAILURE:
    case termConstants.SAVE_FAILURE:
    case termConstants.DELETE_FAILURE:
    case termConstants.ACCEPTANCES_FETCH_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    default:
      return state
  }
}
